// @ts-nocheck
import { Instance } from 'src/types/instance';
import { User } from 'src/types/user';

export const setClarityUser = async (user: User, instance: Instance) => {
  if (!process.env.REACT_APP_CLARITY_ID) {
    return;
  }
  (function (c,l,a,r,i,t,y) {
    c[a] = c[a] || function () {
  (c[a].q = c[a].q || []).push(arguments);
  };
    t = l.createElement(r);t.async = 1;t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    window.clarity?.('identify', `${user.id}`, null, null, `${user.employeeInternalId}`);
    window.clarity('set', 'userId', `${instance.id}`); // window.clarity?.('identify',... is not working for some reason. this line replaces it
    window.clarity?.('set', 'username',`${user.employeeInternalId}`);
    window.clarity('set', 'instanceId', `${instance.id}`);	
    window.clarity('set', 'instanceName', `${instance.name}`);
  })(window, document, 'clarity', 'script', process.env.REACT_APP_CLARITY_ID);
};

export const clearClarityUser = () => {
  window.clarity = null;
};
